<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <!-- Main Content -->
      <v-container fluid class="main-content pa-6">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar"
          @toggle-darkmode="toggleDarkMode" />

        <!-- Loading -->
        <div v-if="loading" class="loader">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <div class="content">
          <v-row class="g-4 mt-4 mb-8" dense>

            <v-col cols="12" sm="12">
              <div class="column-title mb-6">
                <h5 class="m-0 text-left">Account Profile</h5>
                <hr class="title-separator" />
              </div>
            </v-col>

            <v-col cols="12" md="12" class="pa-2">
              <form @submit.prevent="updateprofile">
              <Panel toggleable v-model:collapsed="profileCollapsed">
                <template #header>
                  <div class="flex items-center gap-2">
                    <Button icon="pi pi-user" severity="secondary" rounded text
                      style="color: green; font-size: 1.5rem;" />
                    <span class="font-bold">Profile Details</span>
                  </div>
                </template>
                <template #footer>
                  <div class="flex flex-wrap items-center justify-between gap-4">
                    <div class="flex items-center gap-2">
                      <button type="submit" :disabled="userLoading" class="save-button mb-4">
                        <span v-if="!userLoading">Update Details <v-icon start>mdi-update</v-icon></span>
                        <span v-else>Updating Profile... <v-icon start class="spin">mdi-loading</v-icon></span>
                      </button>
                    </div>
                  </div>
                </template>
                <template #icons>
                  <Menu ref="menu" id="config_menu" :model="items" popup />
                </template>
                <p class="m-0 pa-10">
                  <v-row class="text-left">

                    <!-- Firstname -->
                    <v-col cols="12" md="6">
                      <div class="field">
                        <label>Firstname</label>
                        <input v-model="userForm.firstname" type="text" class="modern-input" />
                      </div>
                    </v-col>

                    <!-- Lastname -->
                    <v-col cols="12" md="6">
                      <div class="field">
                        <label>Lastname</label>
                        <input v-model="userForm.lastname" type="text" class="modern-input" />
                      </div>
                    </v-col>

                    <!-- Username -->
                    <v-col cols="12" md="6">
                      <div class="field">
                        <label>Username</label>
                        <input v-model="userForm.username" type="text" class="modern-input" readonly />
                      </div>
                    </v-col>

                    <!-- Gender -->
                    <v-col cols="12" md="6">
                      <div class="field">
                        <label>Gender</label>
                        <!-- <input v-model="userForm.gender" type="text" class="modern-input" /> -->
                        <select v-model="userForm.gender" class="w-full border rounded px-3 py-2 bg-white modern-input">
                          <option value="" disabled hidden>Select Gender</option>

                          <option v-for="g in gen" :key="g" :value="g">
                            {{ g.charAt(0).toUpperCase() + g.slice(1) }}
                          </option>
                        </select>
                        <!-- <select v-model="userForm.gender" class="w-full border rounded px-3 py-2 bg-white modern-input">
                          <option value="" disabled hidden>Select Gender</option>
                          <option v-for="g in gen" :key="g" :value="g">
                            {{ rel }}
                          </option>
                      </select> -->
                      </div>
                    </v-col>

                    <!-- Email -->
                    <v-col cols="12" md="4">
                      <div class="field">
                        <label>Email</label>
                        <input v-model="userForm.email" type="email" class="modern-input" readonly />
                      </div>
                    </v-col>

                    <!-- Phone -->
                    <v-col cols="12" md="4">
                      <div class="field">
                        <label>Phone</label>
                        <input v-model="userForm.phone" type="text" class="modern-input" />
                      </div>
                    </v-col>

                    <!-- Email -->
                    <v-col cols="12" md="4">
                      <div class="field">
                        <label>Date of Birth</label>
                        <input v-model="userForm.dob" type="email" class="modern-input" readonly />
                      </div>
                    </v-col>

                    <!-- Address -->
                    <v-col cols="12" md="12">
                      <div class="field">
                        <label>Address</label>
                        <input v-model="userForm.address" type="text" class="modern-input" />
                      </div>
                    </v-col>

                  </v-row>
                </p>
              </Panel>
              </form>
            </v-col>

            <v-col cols="12" md="12" class="pa-2">
              <form @submit.prevent="updateNok">
                <Panel toggleable v-model:collapsed="kinCollapsed">
                  <template #header>
                    <div class="flex items-center gap-2">
                      <Button icon="pi pi-users" severity="secondary" rounded text
                        style="color: green; font-size: 1.5rem;" />
                      <span class="font-bold">Next of Kin Details</span>
                    </div>
                  </template>

                  <template #footer>
                    <div class="flex flex-wrap items-center justify-between gap-4">
                      <div class="flex items-center gap-2">
                        <button type="submit" :disabled="nokLoading" class="save-button mb-4">
                          <span v-if="!nokLoading">Update Next of Kin Details <v-icon start>mdi-update</v-icon></span>
                          <span v-else>Updating Next of Kin... <v-icon start>mdi-loading</v-icon></span>
                        </button>
                      </div>
                    </div>
                  </template>
                  <template #icons>
                    <Menu ref="menu" id="config_menu" :model="items" popup />
                  </template>
                  <p class="m-0 pa-10">
                    <v-row class="text-left">
                      <!-- Firstname -->
                      <v-col cols="12" md="6">
                        <div class="field">
                          <label>Next of Kin Firstname</label>
                          <input v-model="nokForm.firstname" type="text" class="modern-input" />
                        </div>
                      </v-col>

                      <!-- Lastname -->
                      <v-col cols="12" md="6">
                        <div class="field">
                          <label>Next of Kin</label>
                          <input v-model="nokForm.lastname" type="text" class="modern-input" />
                        </div>
                      </v-col>

                      <!-- Username -->
                      <v-col cols="12" md="4">
                        <div class="field">
                          <label>Next of Kin Phone</label>
                          <input v-model="nokForm.phone" type="text" class="modern-input" readonly />
                        </div>
                      </v-col>

                      <!-- Email -->
                      <v-col cols="12" md="4">
                        <div class="field">
                          <label>Next of Kin Email</label>
                          <input v-model="nokForm.email" type="email" class="modern-input" readonly />
                        </div>
                      </v-col>


                      <!-- Email -->
                      <v-col cols="12" md="4">
                        <div class="field">
                          <label>Relaationship</label>
                          <select v-model="nokForm.relationship"
                            class="w-full border rounded px-3 py-2 bg-white modern-input">
                            <option value="" disabled hidden>Select Relationship</option>
                            <option v-for="rel in relations" :key="rel" :value="rel">
                              {{ rel }}
                            </option>
                          </select>
                        </div>
                      </v-col>
                    </v-row>
                  </p>
                </Panel>
              </form>
            </v-col>
          </v-row>
        </div>
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
          snackbar.message }}
          <template #actions>
            <v-btn variant="text" @click="snackbar.show = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>

    </v-main>
  </v-app>
</template>


<script setup>
import { ref, onMounted, onUnmounted, reactive, watch } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { updateNextOfKin, updateUserProfile } from "@/api/dashboard"
import { useDashStore } from "@/store/dashboard"
import { getAllErrors } from "@/util"

const dash = useDashStore()

const isSidebarCollapsed = ref(false)
const isDarkMode = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const profileCollapsed = ref(true)
const kinCollapsed = ref(true)
const submitted = ref(false)
const nokLoading = ref(false)
const userLoading = ref(false)
// const user = ref({})
//const defaultImage = "https://gravatar.com/avatar/"

//Snack bar
const snackbar = ref({
  show: false,
  message: "",
  color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
  snackbar.value.message = message
  snackbar.value.color = color
  snackbar.value.show = true
}

const toggleSidebar = () => {
  if (isMobile.value) {
    drawerOpen.value = !drawerOpen.value
  } else {
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value
}

const gen = [
  "male",
  "female"
]

const userForm = reactive({
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  gender: '',
  dob: '',
  username: '',
  address: '',
  userid: ''
})

//Update profile
const updateprofile = async () => {
  submitted.value = true

  userLoading.value = true
  try {
    await updateUserProfile(
      {
        firstname: userForm.firstname.trim(),
        lastname: userForm.lastname.trim(),
        mobile_number: userForm.phone.trim(),
        address_line_1: userForm.address.trim(),
        gender: userForm.gender.trim()
      })
    // SUCCESS MESSAGE
    showSnackbar("Your profile Update was Successful!", "success")
  } catch (e) {
    const msg = getAllErrors(e)
    showSnackbar(
      msg || "Update failed",
      "error"
    )
  } finally {
    userLoading.value = false
  }
}

watch(
  () => dash.user,
  (newVal) => {
    const profile = newVal?.user?.profile || {}
    const user = newVal?.user || {}

    userForm.firstname = profile.firstname || ''
    userForm.lastname = profile.lastname || ''
    userForm.gender = profile.gender || ''
    userForm.dob = profile.dob || ''
    userForm.username = profile.username || ''
    userForm.address = profile.address_line_1 || ''
    userForm.email = user.email || ''
    userForm.phone = user.mobile_number || ''
    userForm.userid = user.uuid || ''
  },
  { immediate: true, deep: true }
)

///Next of Kin
const relations = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Wife",
  "Son",
  "Daughter",
  "Uncle",
  "Aunty"
]

const nokForm = reactive({
  relationship: '',
  firstname: '',
  lastname: '',
  email: '',
  phone: ''
})

watch(
  () => dash.nok,
  (newVal) => {
    if (!newVal) return

    nokForm.firstname = newVal.firstname || ''
    nokForm.lastname = newVal.lastname || ''
    nokForm.phone = newVal.phone || ''
    nokForm.email = newVal.email || ''
    nokForm.relationship = newVal.relationship || ''
  },
  { immediate: true, deep: true }
)


//add or update next of kin
const updateNok = async () => {
  submitted.value = true

  nokLoading.value = true
  try {
    await updateNextOfKin(
      userForm.userid,
      {
        firstname: nokForm.firstname.trim(),
        lastname: nokForm.lastname.trim(),
        email: nokForm.email.trim(),
        phone: nokForm.phone.trim(),
        relationship: nokForm.relationship.trim()
      })
   
    // SUCCESS MESSAGE
    showSnackbar("Next of Kin Update Successful!", "success")
  } catch (e) {
    const msg = getAllErrors(e)
    showSnackbar(
      msg || "Update failed",
      "error"
    )
  } finally {
    nokLoading.value = false
  }
}

onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  await dash.loadUser()
  await dash.loadNok();
  //console.log(nokFirstname.value)
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

//
</script>


<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

.content {
  padding-left: 10%;
  padding-right: 10%;
}

.profile-card {
  border-radius: 16px;
}

.profile-name {
  font-size: 20px;
  font-weight: 600;
}

.profile-role {
  font-size: 14px;
  color: #6b7280;
}

.detail-label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #374151;
}

/* Column title */
.column-title h5 {
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 2.5%;
}

.modern-input {
  width: 100%;
  height: 46px;
  margin-top: 6px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  font-size: 15px;
  background: transparent;
  transition: all 0.2s ease;
}

.modern-input:focus {
  outline: none;
  border-color: #000;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

.spacing {
  margin-bottom: 1em;
}

/* Button */
.save-button {
  width: 40%;
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.save-button:hover {
  background: #292828;
}

.save-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
